import { useEffect, useRef } from 'react';

// Pesanan QR dipanggil kasir: getar + bunyi singkat di HP pelanggan (halaman status pesanan harus masih terbuka).
// Dipicu saat jumlah panggilan BERTAMBAH setelah halaman dimuat (kasir menekan Panggil, termasuk panggilan ulang).
// Keterbatasan browser: bunyi otomatis baru diizinkan setelah pelanggan menyentuh halaman sekali (kita "membuka kunci" audio
// pada sentuhan pertama), dan getar hanya ada di Android/Chrome. Tanpa itu, banner hijau di halaman tetap muncul.
export default function usePanggilanAntrian(jumlahPanggil) {
  const konteks = useRef(null);
  const terakhir = useRef(null);

  // Buka kunci audio pada sentuhan/klik pertama.
  useEffect(() => {
    const buka = () => {
      try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        if (!konteks.current) konteks.current = new AC();
        if (konteks.current.state === 'suspended') konteks.current.resume();
      } catch (_) { /* tidak apa-apa */ }
    };
    window.addEventListener('pointerdown', buka, { passive: true });
    window.addEventListener('keydown', buka);
    return () => {
      window.removeEventListener('pointerdown', buka);
      window.removeEventListener('keydown', buka);
    };
  }, []);

  useEffect(() => {
    const jumlah = Number(jumlahPanggil);
    if (!Number.isFinite(jumlah)) return;
    const sebelum = terakhir.current;
    terakhir.current = jumlah;
    // Pembacaan pertama hanya mencatat (pelanggan membuka halaman setelah dipanggil: cukup banner).
    if (sebelum === null || jumlah <= sebelum) return;

    try {
      if (navigator.vibrate) navigator.vibrate([400, 200, 400, 200, 800]);
    } catch (_) { /* tidak apa-apa */ }

    try {
      const ctx = konteks.current;
      if (ctx && ctx.state === 'running') {
        // tiga bunyi pendek naik nada
        [880, 988, 1175].forEach((frek, i) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = 'sine';
          osc.frequency.value = frek;
          const mulai = ctx.currentTime + i * 0.28;
          gain.gain.setValueAtTime(0.0001, mulai);
          gain.gain.exponentialRampToValueAtTime(0.4, mulai + 0.02);
          gain.gain.exponentialRampToValueAtTime(0.0001, mulai + 0.22);
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.start(mulai);
          osc.stop(mulai + 0.25);
        });
      }
    } catch (_) { /* tidak apa-apa */ }

    // Judul tab berkedip sebentar supaya terlihat walau pelanggan sedang di tab lain.
    try {
      const asli = document.title;
      document.title = 'DIPANGGIL! ' + asli;
      setTimeout(() => { document.title = asli; }, 8000);
    } catch (_) { /* tidak apa-apa */ }
  }, [jumlahPanggil]);
}
